<div class="container">
  <div class="row">
    <div class="col-sm">
      <div class="col-12 row">
        <div class="col-2"></div>
        <h4 class="col-10">{{ "AttachmentsCase" | translate }}</h4>
      </div>
      <hr />

      <table class="table table-striped">
        <tbody *ngFor="let att of RootAttachmentArr">
          <tr>
            <div>
              <td>
                <label style="font-weight: bold;">{{ "AttachmentName" | translate }}: </label>
                <span> {{att.fileName}} </span>&nbsp; &nbsp;
                <label style="font-weight: bold;">{{ "AttachmentType" | translate }}:
                </label> <span> {{att.attachmentTypeName}}</span><br>
                <label style="font-weight: bold;">{{ "incommingOrgName" | translate }}: </label>
                <span *ngIf="att.incommingOrgName=='undefined'"> - </span>
                <span *ngIf="att.incommingOrgName!='undefined'"> {{att.incommingOrgName}}</span>

                <br />
                <label style="font-weight: bold;">{{ "descriptionAtt" | translate }}:
                </label>
                <span *ngIf="att.description=='undefined'"> - </span>
                <span *ngIf="att.description!='undefined'"> {{att.description}}</span>
                <br />
                <label style="font-weight: bold; margin-right: 18px; font-size: 12px" *ngIf="att.creatorName!=null">{{
                  "companyandBy" | translate }}:
                </label>

                <span style="font-size: 12px" *ngIf="att.creatorName!=null">{{
                  att.creatorName}}</span>
                <label style="font-weight: bold; margin-right: 18px; font-size: 12px" *ngIf="att.createdOn!=null">{{
                  "createDate" | translate }}:
                </label>
                <span style="font-size: 12px" *ngIf="att.createdOn!=null">{{ att.createdOn | toDateTime}}</span>

              </td>
            </div>
            <div class="col-12 row">
              <div class="col-6"></div>
              <div class="col-2">
                <a *ngIf="
                   caseStatusId!=caseStatusEnum.Stoped &&
                   caseStatusId!= caseStatusEnum.Saved &&
                   att.isExternal!=true &&
                   CaseDetails  &&
                   ( sharedService.hasCasePermission('P003',CaseDetails.caseTypeId)||
                   sharedService.hasCasePermission('P002',CaseDetails.caseTypeId)||
                   sharedService.hasCasePermission('P007',CaseDetails.caseTypeId)  ||
                    (sharedService.hasCasePermission('P008',CaseDetails.caseTypeId)  && CaseDetails.caseType.allowQualtityToSendToProsecution==true)
                   )" (click)="EditAttachment(att,editAttachment)" class="btn btn-sm btn-outline-primary ms-1 pb-0 ">
                  <app-feather-icons [icon]="'plus'"></app-feather-icons>
                </a>
              </div>
              <div class="col-2">
                <a (click)="download(att);" class="btn btn-sm btn-outline-primary ms-1 pb-0">
                  <app-feather-icons [icon]="'download'"></app-feather-icons>
                </a>
              </div>
              <div class="col-2">
                <a (click)="previewPDF(att,pdfViewer)" class="btn btn-sm btn-outline-dark ms-1 pb-0 ">
                  <app-feather-icons [icon]="'eye'"></app-feather-icons>
                </a>

              </div>
            </div>
          </tr>
        </tbody>
        <hr />
      </table>
    </div>

    <div class="col-sm" style="border-right: 1px solid;">
      <div class="col-12 row">
        <div class="col-2"></div>
        <h4 class="col-10">{{ "AttachmentsCaseList" | translate }}</h4>

      </div>
      <hr />
      <table class="table table-striped ">
        <tbody *ngFor="let item of AttachmentIndexArr">
          <tr>
            <div>
              <td>
                <label style="font-weight: bold;">{{ "AttachmentName" | translate }}: </label>
                <span> {{item.fileName}} </span>&nbsp; &nbsp;
                <label style="font-weight: bold;">{{ "AttachmentType" | translate }}:
                </label> <span> {{item.attachmentTypeName}}</span>
                <br />
                <label style="font-weight: bold;">{{ "incommingOrgName" | translate }}: </label>
                <span *ngIf="item.incommingOrgName=='undefined'"> - </span>
                <span *ngIf="item.incommingOrgName!='undefined'"> {{item.incommingOrgName}}</span>
                <br />
                <label style="font-weight: bold;">{{ "descriptionAtt" | translate }}:</label>
                <span *ngIf="item.description=='undefined'"> - </span>
                <span *ngIf="item.description!='undefined'"> {{item.description}}</span>
                <br />
                <label style="font-weight: bold; margin-right: 18px; font-size: 12px" *ngIf="item.creatorName!=null">{{
                  "companyandBy" | translate }}:</label>

                <span style="font-size: 12px" *ngIf="item.creatorName!=null"> {{
                  item.creatorName}}</span>
                <label style="font-weight: bold; margin-right: 18px; font-size: 12px" *ngIf="item.createdOn!=null">{{
                  "createDate" | translate }}:
                </label>
                <span style="font-size: 12px" *ngIf="item.createdOn!=null"> {{ item.createdOn | toDateTime}}</span>

              </td>

            </div>

            <div class="col-12 row">
              <div class="col-3" style="display: flex; align-items: center; justify-content: center;">
                <i *ngIf="item.isSent==true" class="fa fa-check-circle" style="color:green;"></i>

              </div>
              <div class="col-2">
                <a *ngIf="item.isSent!=true && 
                   caseStatusId!=caseStatusEnum.Stoped &&
                   caseStatusId!= caseStatusEnum.Saved &&
                   CaseDetails  &&(
                   sharedService.hasCasePermission('P003',CaseDetails.caseTypeId) ||
                   sharedService.hasCasePermission('P002',CaseDetails.caseTypeId)  ||
                   sharedService.hasCasePermission('P007',CaseDetails.caseTypeId) ||
                   (sharedService.hasCasePermission('P008',CaseDetails.caseTypeId)  && CaseDetails.caseType.allowQualtityToSendToProsecution==true)
                   )" (click)="DeletePhisicalAttachment(item.caseAttachmentIndexId, confirmPhisicalAttach);"
                  class="btn btn-sm btn-outline-danger ms-1 pb-0 mt-1">
                  <app-feather-icons [icon]="'trash'"></app-feather-icons>
                </a>

              </div>
              <div class="col-2">
                <a (click)="download(item);" class="btn btn-sm btn-outline-primary ms-1 pb-0">
                  <app-feather-icons [icon]="'download'"></app-feather-icons>
                </a>
              </div>
              <div class="col-2">
                <a (click)="previewPDF(item,pdfViewer)" class="btn btn-sm btn-outline-dark ms-1 pb-0 ">
                  <app-feather-icons [icon]="'eye'"></app-feather-icons>
                </a>

              </div>
              <div class="col-3">
                  <button *ngIf="item.isSent == null && caseService.case.stageId==102" (click)="sendIndex(item.caseAttachmentIndexId);"
                          class="btn btn-sm btn-outline-dark ms-1 p-1 ">
                      <i class="fa fa-envelope fa-lg"></i>
                      {{"SendFileToProsection" |  translate }}
                  </button>
                  

              </div>
            </div>
            <div class="col-12" style="color:red;">


                <i *ngIf="item.isSent==false" class="fa fa-times-circle-o" ></i>
                &nbsp;
                <span *ngIf="item.isSent==false && item.response.indexOf('the request entity is too large')!=-1" style="font-size:x-small;">
                    {{'AttachmentNotSentToProsecution'|translate}} :
                    {{'SizeOfAttachmentNotAllow'|translate}}   <b><a style="text-decoration: underline; cursor: pointer;" (click)="detailsMassage(item,Detailsmassage)">{{'Details'|translate}}</a></b>
                </span>



                <span *ngIf="item.isSent==false && item.response.indexOf('Cannot connect to the back-end')!=-1" style="font-size:x-small;">
                    {{'AttachmentNotSentToProsecution'|translate}} :
                    {{'CommunicationFailureBetweenProsecutionServiceAndNationalInformationCenter' | translate }}  <b><a style="text-decoration: underline; cursor: pointer;" (click)="detailsMassage(item,Detailsmassage)">{{'Details'|translate}}</a></b>
                </span>



                <span *ngIf="item.isSent==false && item.response.indexOf('502 Bad Gateway')!=-1" style="font-size:x-small;">
                    {{'AttachmentNotSentToProsecution'|translate}} :
                    {{'CommunicationFailedBetweenIssueSystemServiceAndIntermediatePoint'  | translate}}  <b><a style="text-decoration: underline; cursor: pointer;" (click)="detailsMassage(item,Detailsmassage)">{{'Details'|translate}}</a></b>
                </span>



                <span *ngIf="item.isSent==false && item.response.indexOf('Your support ID is')!=-1" style="font-size:x-small;">
                    {{'AttachmentNotSentToProsecution'|translate}} :
                    {{'ErrorReceivedFromNationalInformationCenterSystem' | translate }}  <b><a style="text-decoration: underline; cursor: pointer;" (click)="detailsMassage(item,Detailsmassage)">{{'Details'|translate}}</a></b>
                </span>





                <span *ngIf="item.isSent==false && item.response.indexOf('Object reference not set to an instance of an object')!=-1" style="font-size:x-small;">
                    {{'AttachmentNotSentToProsecution'|translate}} :
                    {{'ErrorOccurredDuringTheSendingProcess' | translate }}   <b><a style="text-decoration: underline; cursor: pointer;" (click)="detailsMassage(item,Detailsmassage)">{{'Details'|translate}}</a></b>
                </span>



                <span *ngIf="item.isSent==false && item.response.indexOf('ER0000')!=-1 && item.response.indexOf('ReceptionCode')!=-1" style="font-size:x-small;">
                    {{'AttachmentNotSentToProsecution'|translate}} :
                    {{'ErrorReceivedFromPublicProsecution' | translate }}  <b><a style="text-decoration: underline; cursor: pointer;" (click)="detailsMassage(item,Detailsmassage)">{{'Details'|translate}}</a></b>
                </span>


            </div>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-12 row">
      <div class="col-4"></div>
      <div class="col-4">
          <button *ngIf="caseService.case.stageId==102 &&
                  (
                   (sharedService.hasCasePermission('P008',CaseDetails.caseTypeId)  && CaseDetails.caseType.allowQualtityToSendToProsecution==true)  ||
                   (sharedService.hasCasePermission('P003',CaseDetails.caseTypeId)  && CaseDetails.caseType.allowQualtityToSendToProsecution==false) ||
                  sharedService.hasCasePermission('P007',CaseDetails.caseTypeId)
                  
                  )
                  
                  " class="btn btn-primary" (click)="sendCaseToProsecution(CaseDetails.eCaseId)">
              <i class="fa fa-envelope fa-lg"></i>

              {{"SendCaseToProsection" |   translate }}
          </button>
      </div>
      <div class="col-4"></div>

    </div>

  </div>
</div>


<ng-template #editAttachment let-modal>
  <div class="modal-header" style="justify-content: space-between">
    <div></div>
    <h4 class="modal-title" id="modal-basic-title">
      {{ "Edit" | translate }}
    </h4>
    <i style="font-size: 20px;" class="fa fa-close" (click)="modal.dismiss('Cross click');"></i>
  </div>
  <div class="modal-body">
    <div class="form-group  row">
      <div class="col-12 offset-1 ">
        <div class="card rounded-2  flex-md-row row">
          <div class="form-group mt-3">
            <div style="display: flex; flex-wrap: nowrap; height: 30px">
              <label>{{ "incommingOrgName" | translate }}</label>
            </div>
            <input [(ngModel)]="IncommingOrgName" type="text" class="form-control" />
          </div>
          <div class="form-group mt-3">
            <div style="display: flex; flex-wrap: nowrap; height: 30px">
              <label>{{ "descriptionAtt" | translate }}</label>
            </div>
            <input [(ngModel)]="description" type="text" class="form-control" />
          </div>
        </div>
      </div>

    </div>

  </div>
  <div class="modal-footer row" style="justify-content: space-between;padding: 1rem 2rem;">
    <button style="color: black;font-weight: bold;" type="button" class="btn btn-primary col-lg-3"
      data-bs-dismiss="modal" (click)="onAddAttach(modal);">
      {{"Add" | translate}}
    </button>
    <button type="button" class="btn btn-danger col-lg-3" (click)="modal.dismiss('Cross click');">
      {{ "Close" | translate }}
    </button>
  </div>
</ng-template>
<ng-template #confirmPhisicalAttach let-modal>
  <div class="modal-header" style="justify-content: center">
    <h5 class="modal-title text-danger" id="modal-basic-title">
      <b> <app-feather-icons [icon]="'alert-triangle'" style="position:relative; top:4px;"></app-feather-icons> {{
        "ConfirmDeleteOperation" | translate }}</b>
    </h5>
  </div>
  <div class="modal-body text-center">
    <p class="alert fs-6">{{ "SelectedRecordwillbeDeleted" | translate }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="onDeletePhisicalAttach(modal)">
      {{ "Yes" | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
      {{ "No" | translate }}
    </button>
  </div>
</ng-template>

<ng-template #pdfViewer let-modal>

  <div class="modal-body text-center">


    <div style="position:absolute; top:40%; left:45%;  z-index:-1;">
      <div class="spinner-border text-success" role="status">
      </div>
      <br />
      <br />
      <span> {{'uploadFile'|translate}} ...</span>
    </div>
    <i (click)="modal.dismiss('Cross click')" style="position: absolute;z-index: 1;left: 45px;font-size: 25px;"
      class="fa fa-close"></i>

    <!-- -->
    <pdf-viewer *ngIf="pdfFile" [src]="doc" [render-text]="true" [original-size]="false" [show-all]="true"
      [show-borders]="true">


    </pdf-viewer>

    <img style="width:100%;" *ngIf="!pdfFile" [src]="image" alt="">
  </div>
</ng-template>


<ng-template #Detailsmassage let-modal>
  <div class="modal-header" style="justify-content: space-between">
    <div></div>
    <h4 class="modal-title" id="modal-basic-title">
      {{ "Details" | translate }}
    </h4>
    <i style="font-size: 20px;" class="fa fa-close" (click)="modal.dismiss('Cross click');"></i>
  </div>
 
  <div class="modal-body text-center">
      <p>
          {{MassageResponse}}<br />
          
          <span *ngIf="showAssignResponse">{{'PleaseOpenReportWithTheBasherSystem' | translate}}</span>
      </p>
  </div>
  <!-- <div class="modal-footer">
  
    <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
      {{ "No" | translate }}
    </button>
  </div> -->
</ng-template>